<template>
<!--  해당 화면 <head>의 viewport는 따로 작업 필요합니다.-->
  <div>
    <router-view name="conferenceBody" key="conferenceBody"></router-view>
    <router-view name="conferencePlayer" key="conferencePlayer"></router-view>
    <div class="popup-back" :style="`display: ${isOpenPopup ? 'block' : 'none'}`">
      <div class="popup">
        <div class="popup-button-close">
          <button type="button" @click="closeConferencePopup">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAP9JREFUSA3tlUsKwjAQhou3cyWuu2t3vYDgAXovPUi7EbyDCvULdEoZzYsmG83AT/qYf75kQkhVlSgd+JsOTNN0QFdUxy4azx5dUBvrrTAZqEQXWgDDET1m4xjqW/Iw1rNZBi+cxDXU+E5LwZgHjJ1xr8IKJ0dD+xjWRy4FvfDkUJmFC54N6oJnhzrgT+AS2/ZUILYRit5zA46G7mwAx/c7/17q/029p31lZfrImNVKWI/apllQXUN7vum2p4V/g8oqssFd0GzwEGhyOFBztcktw6P/yJCj97yRiQWPFDH3qUTwOcWwhg/BQEmkQItGFH214WnQgM5Sr4ylA7/fgTe/2zTk30iqjgAAAABJRU5ErkJggg==" alt="btn-close">
          </button>
        </div>
        <div class="popup-content">
          <h1 v-html="conferenceTitle.replace('\n', '<br>')"></h1>
<!--          <h2>행사 서브 타이틀</h2>-->
          <div v-html="conferenceContent"></div>
        </div>
      </div>
    </div>
    <!-- /popup -->
  </div>
</template>
<script>
import { changeViewPort, VIEWPORT_VALUE_CONFERENCE_MODE } from '@/common/utils/viewport.utils'
import _ from 'lodash'

export default {
  name: 'ConferenceLayout',
  data () {
    return {
      componentKey: 0,
      isOpenPopup: false,
      conferenceMeta: null
    }
  },
  methods: {
    closeConferencePopup () {
      this.isOpenPopup = false
    }
  },
  computed: {
    conferenceTitle () {
      return _.get(this.conferenceMeta, 'player_info.title', '')
    },
    conferenceContent () {
      return _.get(this.conferenceMeta, 'player_info.content', '')
    }
  },
  created () {
    this.$events.$on('OPEN_CONFERENCE_INFO_POPUP', (conferenceInfo) => {
      this.conferenceMeta = conferenceInfo
      console.log('conferecne MEta : ', conferenceInfo)
      this.$nextTick(() => {
        this.isOpenPopup = true
      })
    })
    changeViewPort(VIEWPORT_VALUE_CONFERENCE_MODE)
  },
  beforeDestroy () {
    this.$events.$off('OPEN_CONFERENCE_INFO_POPUP')
  }
}
</script>
<style lang="css" src="@/pages/conference/css/base.css"></style>
<style lang="css" src="@/pages/conference/css/shareholder.css"></style>
